import { AdditionalProductDTO, AddonDTO } from "../models/cart/item.model";


export class AddonsVO {
  readonly productFormatId: string | null;
  readonly price: number;
  readonly addons: AddonDTO[];

  constructor(data?: AdditionalProductDTO) {
    this.productFormatId = data?.productFormatId ?? null;
    this.price = data?.price ?? 0;
    this.addons = data?.addons ?? [];
  }

  get unitPriceIncrease(): number {
    const addonsTotal = this.addons.reduce(
      (sum, addon) => sum + addon.price * addon.quantity,
      0,
    );

    return addonsTotal;
  }

  equals(other?: AddonsVO): boolean {
    if (this === other) {
      return true;
    }

    if (!other) {
      return false;
    }

    return (
      this.productFormatId === other.productFormatId
      && this.price === other.price
      && this.addons.length === other.addons.length
      && this.addons.every((a, i) => {
        const b = other.addons[i];

        return (
          a.id === b.id &&
          a.price === b.price &&
          a.quantity === b.quantity
        );
      })
    );
  }

  toDTO(): AdditionalProductDTO | undefined {
    const isEmpty = !this.productFormatId && this.addons.length === 0;

    if (isEmpty) {
      return undefined;
    }

    return {
      productFormatId: this.productFormatId ?? null,
      price: this.price,
      addons: this.addons,
    };
  }

  static areDTOsEqual(a?: AdditionalProductDTO, b?: AdditionalProductDTO,): boolean {
    const left = new AddonsVO(a);
    const right = new AddonsVO(b);

    return left.equals(right);
  }
}
